// The source of truth for these values is in _variables.scss:
export const responsiveBreakpointsPx = {
    xs: 0,
    sm: 540,
    md: 768,
    lg: 1024,
    xl: 1336,
};
